import { CanDeactivateFn, GuardResult, MaybeAsync } from '@angular/router';

/** Any component that implements this contract can be guarded by the unsaved-changes guard. */
export interface UnsavedChangesAware {
  canDeactivate?: () => MaybeAsync<GuardResult>;
}

/**
 * Generic route guard that prevents navigation away from a page with unsaved changes.
 * The component must implement `canDeactivate()`.
 */
export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesAware> = (component) => {
  if (!component?.canDeactivate) {
    return true;
  }
  return component.canDeactivate();
};
